import React ,{useEffect}from 'react'
import { useNavigate } from 'react-router-dom';

function AddRooms(){
    const navigate = useNavigate();
    useEffect(() => {
        const scriptUrls = [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',


        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
      // Optional: Add form validation logic here
      navigate("/available-rooms");
      setTimeout(() => {
          window.location.reload(); // force page refresh after navigation
      }, 100);
  };
    return(<>
         <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <button
              onClick={() => navigate("/")}
              className="btn btn-link p-0 border-0 text-decoration-none"
            >
              <i className="ri-home-3-line" />
            </button>
          </li>
          <li className="breadcrumb-item">Rooms</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Add Room
          </li>
        </ol>
        {/* Breadcrumb ends */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
      </div>
      {/* App Hero header ends */}

      {/* App body starts */}
      <div className="app-body">
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Add New Room</h5>
              </div>
              <div className="card-body">
                <div className="row gx-4 justify-content-center">
                  <div className="col-sm-4">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a1">Room Number</label>
                      <input type="text" className="form-control" id="a1" placeholder="Enter Room Number" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a2">Floor No</label>
                      <input type="email" className="form-control" id="a2" placeholder="Enter Floor Number" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a3">Room Type</label>
                      <select className="form-select" id="a3">
                        <option value={0}>Select</option>
                        <option value={1}>Standard</option>
                        <option value={2}>Deluxe</option>
                        <option value={3}>Suite</option>
                        <option value={4}>Private</option>
                        <option value={5}>Ward</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a4">Department</label>
                      <select className="form-select" id="a4">
                        <option value={0}>Select</option>
                        <option value={1}>Surgeon</option>
                        <option value={2}>Gynecologist</option>
                        <option value={3}>Psychiatrists</option>
                        <option value={4}>Urologist</option>
                        <option value={5}>Paediatrician</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a5">Enter Message</label>
                      <textarea className="form-control" id="a5" placeholder="Enter message" rows={3}></textarea>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        onClick={() => navigate("/available-rooms")}
                        className="btn btn-outline-secondary"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleSubmit}
                        className="btn btn-primary"
                      >
                        Add New Room
                      </button>
                    </div>
                  </div>
                </div>
                {/* Row ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
    </div>
    </>)
}
export default AddRooms;
